<template>
  <div class="breadcrumbs">
    <div>
      <p v-for="(element, index) in list" :key="index">
        <router-link class="little-large_white_label" :to="element.path">
          {{element.displayName}}
        </router-link>
        <span class="little-large_white_label" v-if="index + 1 < list.length">}</span>
      </p>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from "vuex";

  export default {
    name: "Breadcrumbs",

    computed: {
      ...mapGetters({list: 'breadcrumbs/list'}),
    },

  }
</script>


<style lang="scss">
  .breadcrumbs {
    display: flex;
    justify-content: center;

    > div {
      display: flex;
      > p {
        > a, > span {
          margin-right: 1rem;
        }
      }
      @media screen and (min-width: 767px) {
        width: 600px;
      }
    }
  }
</style>